export const Emotes = {
  IDLE: 'asset://emote-idle.glb',
  WALK: 'asset://emote-walk.glb',
  RUN: 'asset://emote-run.glb',
  FLOAT: 'asset://emote-float.glb',
  FALL: 'asset://emote-fall.glb',
  FLIP: 'asset://emote-flip.glb',
  TALK: 'asset://emote-talk.glb',
}

export const emoteUrls = [Emotes.IDLE, Emotes.WALK, Emotes.RUN, Emotes.FLOAT, Emotes.FALL, Emotes.FLIP, Emotes.TALK]
